import {
	GET_USER_ROLES,
	GET_USER_ROLES_SUCCESS,
	GET_USER_ROLES_ERROR,
	SET_USER_ROLE,
	SET_USER_MERCHANT_DETAILS,
} from './types';

const defaultState = {
	loading: false,
	error: undefined,
	isFetched: false,
};

export const initialState = {
	// user profile related keys
	userRolesList: { ...defaultState, data: [] },
	userRole: {},
	// isLoggedIn: false,
	// userDetails: { ...defaultState, data: {}},
	// userPermissions: { ...defaultState, data: []},
	// userGroups: { ...defaultState, data: []},

	// user merchant related keys
	// merchantType: null,
	// isSuperMerchant: false,
	// merchantList: { ...defaultState, data: []},
	// merchantProfile: { ...defaultState, data: {}},
};

function getUserInfo(state = initialState, action) {
	switch (action.type) {
		case GET_USER_ROLES:
			return {
				...state,
				userRolesList: {
					...defaultState,
					loading: true,
					data: [],
				},
			};
		case GET_USER_ROLES_SUCCESS:
			return {
				...state,
				userRolesList: {
					...defaultState,
					isFetched: true,
					data: action.data,
				},
			};
		case GET_USER_ROLES_ERROR:
			return {
				...state,
				userRolesList: {
					...defaultState,
					isFetched: true,
					data: [],
					error: action.error,
				},
			};
		case SET_USER_ROLE:
			return {
				...state,
				userRole: action.data,
			};

		case SET_USER_MERCHANT_DETAILS:
			return {
				...state,
				...action.data,
			};
		default:
			return state;
	}
}

export default getUserInfo;
